import { connect } from 'react-redux'
import { Actions as OrderActions } from 'state/orders'
import { getFormValues, getFormInitialValues } from 'redux-form'

const mapStateToProps = (state, props) => ({
  initialValues: getFormInitialValues('measurements')(state),
  formValues: getFormValues('measurements')(state),
})

const mapDispatchToProps = {
  updateMeasurementsAndOrder: OrderActions.updateMeasurementsAndOrder,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)
